import { FormDataProps } from "../CalculatorTypes"
import { useEffect } from "react"

export default function Step4({ formData }: { formData: FormDataProps }) {
    useEffect(() => {
        const script = document.createElement("script")
        script.src =
            "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
        script.type = "text/javascript"
        document.body.appendChild(script)

        return () => {
            document.body.removeChild(script)
        }
    }, [])

    return (
        <>
            <div className="step4 w-full mx-auto p-6 space-y-4 pb-0">
                <h3 className="text-xl font-bold text-center">
                    Calcolatore completato con successo!
                </h3>
                <p className="text-center calculator-text font-light">
                    Grazie{" "}
                    <span className="font-semibold">{formData.firstName}</span>,
                    per aver utilizzato il nostro calcolatore.
                </p>
                <p className="text-center calculator-text font-light">
                    Ti invieremo il risultato via e-mail.
                </p>
                <p className="text-center calculator-text font-semibold">
                    Prenota ora un appuntamento per mettere in pratica il tuo
                    risultato:
                </p>
            </div>
            <div className="flex justify-center items-center w-full mt-4 lg:mt-0">
                <div
                    className="meetings-iframe-container w-full"
                    data-src="https://www.blytzcashless.it/meetings/gchiochetti/discovery?embed=true"
                />
            </div>
        </>
    )
}
